<template>
  <div>
    <el-table :data="data" class="hidden lg:block table-product" :empty-text="$t('common.placeholder.noDataText')">
      <el-table-column :label="$t('ec-line003.itemTable.product')" width="280">
        <template slot-scope="scope">
          <div class="flex items-center justify-start">
            <img :src="image(scope.row)" width="100" height="100" />
            <div class="text-base font-bold text-black ml-4">{{ scope.row.product_name }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="108">
        <template #header>
          <span>{{ $t('ec-line003.itemTable.sku') }}</span>
        </template>
        <template slot-scope="scope">
          <div class="text-sm mt-b break-all" v-if="scope.row.sku_item_parent_name_1">
            <span class="font-bold">{{ scope.row.sku_item_parent_name_1 }}</span
            >:
            <span class="ml-2">{{ scope.row.sku_set_item_name1 }}</span>
          </div>
          <div class="text-sm mt-b break-all" v-if="scope.row.sku_item_parent_name_2">
            <span class="font-bold">{{ scope.row.sku_item_parent_name_2 }}</span
            >:
            <span class="ml-2">{{ scope.row.sku_set_item_name2 }}</span>
          </div>
          <div class="text-sm break-all" v-if="!scope.row.sku_item_parent_name_2 || !scope.row.sku_item_parent_name_1">
            <span class="font-bold">{{ $t('common.hyphenSeparator') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sku" width="108">
        <template #header>
          <span>{{ $t('ec-line003.itemTable.price') }}</span>
          <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
        </template>
        <template slot-scope="scope">
          <span class="text-lg font-normal">{{
            $t('common.unit.priceWithoutTax', {
              price: $n(
                isSubscription ? Number(scope.row.price03_after_tax) : Number(scope.row.price02_after_tax),
                'currency',
                'ja-JP'
              ),
            })
          }}</span>
          <br />
        </template>
      </el-table-column>
      <el-table-column :label="$t('ec-line003.itemTable.quantity')" prop="quantity" width="108">
        <template slot-scope="scope">
          <span v-if="scope.row.is_out_stock" class="text-red whitespace-pre-line text-center">{{
            $t('ec-line003.content.outOfStock')
          }}</span>
          <el-form-item
            v-else-if="isSubscription"
            :prop="'subscriptionCarts.' + scope.$index + '.quantity'"
            :rules="rules"
          >
            <base-input-number
              :value="scope.row.quantity"
              :max-value="scope.row.sale_limit"
              :min-value="1"
              @input="(value) => onChange(scope.row, value)"
            ></base-input-number>
          </el-form-item>
          <el-form-item v-else :prop="'normalCarts.' + scope.$index + '.quantity'" :rules="rules">
            <base-input-number
              :value="scope.row.quantity"
              :max-value="scope.row.sale_limit"
              :min-value="1"
              @input="(value) => onChange(scope.row, value)"
            ></base-input-number>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column width="200">
        <template #header>
          <div class="item-table-subtotal">
            <span>{{ $t('ec-line003.itemTable.subTotal') }}</span>
            <span class="font-normal text-xs">{{ $t('cartList.item.withTax') }}</span>
            <span>{{ $t('ec-line003.itemTable.discount') }}</span>
          </div>
        </template>
        <template slot-scope="scope">
          <span v-if="!scope.row.is_out_stock">
            {{
              $t('common.unit.priceWithoutTax', {
                price: $n(
                  isSubscription
                    ? scope.row.product_subtotal_price03_after_tax
                    : scope.row.product_subtotal_price02_after_tax,
                  'currency'
                ),
              })
            }}
          </span>
          <div v-if="hasDiscountAmount(scope.row)" class="text-xs">
            <span> {{ $t('common.label.priceDiscount') }}</span>
            <span class="text-red ml-1">{{ $n(scope.row.product_subtotal_discount_amount, 'currency', 'ja-JP') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column class-name="no-border" label="" width="76">
        <template slot-scope="scope">
          <el-button
            class="ml-auto text-gray-150 py-0 my-2 font-normal text-sm"
            type="text"
            @click="removeItem(scope.row)"
            >{{ $t('common.action.delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import BaseInputNumber from '@/components/BaseInputNumber.vue'
export default {
  components: { BaseInputNumber },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isSubscription: { type: Boolean, default: false },
  },
  data() {
    const mappingMaxValue = (rule, value, callback) => {
      const index = parseInt(rule.field.split(/[.]/)[1])
      const saleLimit = this.data[index].sale_limit
      if (saleLimit && value > saleLimit) {
        callback(new Error(this.$t('common.cart.maxInputNumber', { val: saleLimit })))
      }

      callback()
    }
    return {
      rules: [
        {
          validator: mappingMaxValue,
          trigger: ['change', 'blur'],
        },
      ],
    }
  },
  methods: {
    removeItem(data) {
      this.$emit('remove', { id: data.id, subscription: this.isSubscription })
    },
    toDetailPage() {
      this.$router.push({ name: 'EC_LINE002', params: { id: this.data.product_id } })
    },
    image(data) {
      return this.isValid(data) ? data.product_image : require('@/assets/images/gray-image.svg')
    },
    isValid(data) {
      return data.visible && [undefined, true].includes(data.is_product_sku_valid) && data.is_out_stock === false
    },
    onChange(item, val) {
      if (item.sale_limit && parseInt(val) > item.sale_limit) {
        this.handleError({
          message: this.$t('common.cart.saleLimitToast', { name: item.product_name, saleLimit: item.sale_limit }),
        })
      }
      this.$emit('update-quantity', {
        id: item.id,
        quantity: Number(val) || val,
        subscription: Number(this.isSubscription),
      })
    },
    priceWithDiscount(price, discount_amount) {
      const priceTotal = price + (discount_amount != null ? discount_amount : 0)
      return Math.max(priceTotal, 0)
    },
    hasDiscountAmount(item) {
      return item.product_subtotal_discount_amount && Number(item.product_subtotal_discount_amount) < 0
    },
  },
}
</script>
